import { render, staticRenderFns } from "./InstitutionsView.vue?vue&type=template&id=19b13173&scoped=true&"
import script from "./InstitutionsView.vue?vue&type=script&lang=js&"
export * from "./InstitutionsView.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionsView.vue?vue&type=style&index=0&id=19b13173&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b13173",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCheckbox,VDataTable,VDialog,VIcon})
